import React, { useState, useEffect } from 'react';

function IndoorGamesForm ({ setNotificationTitle, setNotificationMessage, setModalShow}){
    return (
        <div></div>
    )

}
export default IndoorGamesForm;